import React, { FC } from "react";
import "./ProductItemNoCol.scss";
import { Link } from "react-router-dom";
import AddWishList from "../AddWishList/AddWishList";
import ImageSrc from "../../../../../Components/ImageSrc/ImageSrc";
import { CurrencyFormatter } from "../../../../../Helpers";

interface propsType {
  data: {
    productUuid: string;
    productName: string;
    productDescription: string;
    minimumQuantity: number;
    maximumQuantity: number;
    unitOfMeasurement: string;
    totalNumberOfRatings: string;
    images: any[];
    sellerPublicProfile: {
      businessProfile: {
        businessName: string;
        usinessAddress: string;
      };
      photoUrl: string;
    };
    unitPriceForBuyer: number;
    unitPromoPriceForBuyer: number;
    currencySymbol: string;
  };
}
const ProductItemNoCol: FC<propsType> = ({ data }) => {
  return (
    <div className="product-item-card row g-2">
      <div className="imgWrapper ">
        <div className="propertyCon">
          <Link to={`/product/${data.productUuid}`}>
            <ImageSrc
              src={data?.images[0]?.url}
              alt={data.productName}
              title={data.productName}
              width="product-image mt-3 w-100"
            ></ImageSrc>
          </Link>
        </div>

        <div className="col-12 d-none">
          <div className="row">
            <div className="col-3">
              <div className="brand-logo-cont">
                <img
                  src={data.sellerPublicProfile.photoUrl}
                  className="brand-logo rounded"
                  alt=""
                />
              </div>
            </div>
            <div className="col-9 text-end">
              <AddWishList productUuid={data.productUuid}></AddWishList>
            </div>
          </div>
        </div>

        <div className="contentConstructionDetails">
          <div className="col-12">
            <Link
              to={`/product/${data.productUuid}`}
              className="text-decoration-none"
            >
              <h3 className="productTitle">{data.productName}</h3>
            </Link>
          </div>

          <div className="priceUnit">
            <div className="firstCon">
              {data.unitPromoPriceForBuyer !== 0 ? (
                <>
                  <span className="old-price">
                    {data.currencySymbol}
                    {CurrencyFormatter(data.unitPromoPriceForBuyer)}
                  </span>
                  <span className="perUnit">per unit</span>
                </>
              ) : data.unitPriceForBuyer !== 0 ? (
                <>
                  <span className="new-price">
                    {data.currencySymbol}
                    {CurrencyFormatter(data.unitPriceForBuyer)}
                  </span>
                  <span className="perUnit">per unit</span>
                </>
              ) : (
                <Link
                  to={`/product/${data.productUuid}`}
                  className="request-quote text-decoration-none"
                >
                  Request quote
                </Link>
              )}
            </div>
            <span className="units">{data.maximumQuantity}units</span>
          </div>

          <div className="d-none">
            <div className="col-4">
              {data.totalNumberOfRatings && (
                <div className="rating">
                  <span className="d-icon d-star"></span>
                  {data.totalNumberOfRatings}/5
                </div>
              )}
            </div>

            <div className="col-8 mt-2">
              <div className="company-name">
                {data.sellerPublicProfile?.businessProfile?.businessName}
              </div>
            </div>

            <div className="col-4 mt-2">
              <div className="location">
                <span className="d-icon d-location"></span>
                Lagos
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItemNoCol;

// import React, { FC } from "react";
// import "./ProductItemNoCol.scss";
// import { Link } from "react-router-dom";
// import AddWishList from "../AddWishList/AddWishList";
// import ImageSrc from "../../../../../Components/ImageSrc/ImageSrc";
// import { CurrencyFormatter } from "../../../../../Helpers";

// interface propsType {
//   data: {
//     productUuid: string;
//     productName: string;
//     productDescription: string;
//     minimumQuantity: number;
//     maximumQuantity: number;
//     unitOfMeasurement: string;
//     totalNumberOfRatings: string;
//     images: any[];
//     sellerPublicProfile: {
//       businessProfile: {
//         businessName: string;
//         usinessAddress: string;
//       };
//       photoUrl: string;
//     };
//     unitPriceForBuyer: number;
//     unitPromoPriceForBuyer: number;
//     currencySymbol: string;
//   };
// }
// const ProductItemNoCol: FC<propsType> = ({ data }) => {
//   return (
//     <div className="related-products-card row g-4">
//       <div className="imgWrapper ">
//         <div className="propertyCon">
//           <Link to={`/product/${data.productUuid}`}>
//             <ImageSrc
//               src={data?.images[0]?.url}
//               alt={data.productName}
//               title={data.productName}
//               width="product-image mt-3 w-100"
//             ></ImageSrc>
//           </Link>
//         </div>

//         <div className="col-12 d-none">
//           <div className="row">
//             <div className="col-3">
//               <div className="brand-logo-cont">
//                 <img
//                   src={data.sellerPublicProfile.photoUrl}
//                   className="brand-logo rounded"
//                   alt=""
//                 />
//               </div>
//             </div>
//             <div className="col-9 text-end">
//               <AddWishList productUuid={data.productUuid}></AddWishList>
//             </div>
//           </div>
//         </div>

//         <div className="col-12">
//           <Link
//             to={`/product/${data.productUuid}`}
//             className="text-decoration-none"
//           >
//             <h4
//               className="product-title product-title-related"
//               style={{ height: "40px" }}
//             >
//               {data.productName}
//             </h4>
//           </Link>
//         </div>

//         <div className="col-8">
//           {data.unitPromoPriceForBuyer !== 0 ? (
//             <div className="price">
//               <div className="old-price">
//                 {data.currencySymbol}
//                 {data.unitPromoPriceForBuyer}
//               </div>
//               <div className="new-price">
//                 {data.currencySymbol}
//                 {CurrencyFormatter(data.unitPriceForBuyer)}
//               </div>
//             </div>
//           ) : (
//             <div className="price">
//               <div className="new-price">
//                 {data.unitPriceForBuyer !== 0 ? (
//                   <>
//                     {data.currencySymbol}
//                     {CurrencyFormatter(data.unitPriceForBuyer)}
//                   </>
//                 ) : (
//                   <>
//                     <Link
//                       to={`/product/${data.productUuid}`}
//                       className="new-price text-decoration-none"
//                     >
//                       Request quote
//                     </Link>
//                   </>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="col-4">
//           {data.totalNumberOfRatings && (
//             <div className="rating">
//               <span className="d-icon d-star"></span>
//               {data.totalNumberOfRatings}/5
//             </div>
//           )}
//         </div>

//         <div className="col-8 mt-2">
//           <div className="company-name">
//             {data.sellerPublicProfile?.businessProfile?.businessName}
//           </div>
//         </div>

//         <div className="col-4 mt-2">
//           <div className="location">
//             <span className="d-icon d-location"></span>
//             Lagos
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductItemNoCol;

// <div className="related-products">
//   <h2>Related Products</h2>
//   <div className="imgWrapper">
//     <div className="propertyCon row g-4">
//       {images
//         .filter((image) => image.returnThis === 4)
//         .map((image, index) => (
//           <div key={index} className="col-12 col-sm-6 col-lg-3">
//             <a href={`/estate-home/property-details/${image.id}`}>
//               <img className="img-fluid" src={image.src} alt={image.alt} />
//             </a>
//             <div className="contentConstructionDetails">
//               <div className="priceUnit">
//                 <div className="firstCon">
//                   <span>{image.price}</span>
//                   <span className="perUnit">per unit</span>
//                 </div>
//                 <span className="units">{image.noOfUnits}units</span>
//               </div>
//               <h3>{image.name}</h3>
//             </div>
//           </div>
//         ))}
//     </div>
//   </div>
// </div>;
